import Style from "@/prototype/utils/Style.js";

import global from "@/prototype/global.js";

import uuid from "@/library/uuid.js";

import Transform from "./Transform.js";

import {make_ids_unique} from "svg-utils";

const d3 = global.d3;

const log = global.log.getLogger("f_mtac.scene.trace");
log.setLevel(log.levels.WARN);

let Trace = function (group) {
    const marker_id = uuid();

    const points = [
        [0, 27],
        [9, 27],
        [0, 0],
        [-9, 27]
    ];
    const marker = d3.create("svg:polygon").attr("id", marker_id).attr("fill", "#000").attr("stroke", "#fff").attr("stroke-width", "0.5").attr("class", "trace_marker").attr("points", points);
    const marker_group = d3.create("svg:g");

    var marker_offset = 0;

    const line_1 = d3.create("svg:line").attr("stroke-width", "3").attr("stroke", "transparent");
    const line_2 = d3.create("svg:line").attr("stroke", "#000").attr("stroke-width", "3").attr("stroke-dasharray", "0.9").attr("opacity", "0.8");

    var node = null;
    const style = $("<style/>").prop("type", "text/css").appendTo("head");
    this.update_geo_style = () => {
        style.html(`#geolocation .geonode.geonode-trace > g.color > circle { fill: transparent; stroke: ${global.storage.selected_context.projection.project === null ? "var(--mtac-btn-gray)" : "var(--mtac-blue)"};}`);
    };

    // Depending of the node type, will hide specific htlm elements to create a more logical copy
    const node_mirror = (handle) => {
        node = d3.select(handle.node().cloneNode(true));
        log.debug("Trace.node_mirror", node);
        if (handle.select("g.node").classed("resource")) {
            node.select("g.color circle")
                .attr("r", 79)
                .attr("visibility", "visible")
                .attr("fill", "transparent")
                .attr("stroke", handle.select("g.color circle.color").attr("fill"))
                .attr("stroke-width", 8 * global.resources.scale * 2);
            node.select("g.figure").remove();
            node.select("g.name").remove();
            node.select("g.user_name").remove();
            node.select("g.stream").remove();
        } else if (handle.select("g.node").classed("attachment")) {
            node.select("g.color circle")
                .attr("r", 79)
                .attr("fill", "transparent")
                .attr("stroke", handle.select("g.color circle.color").attr("fill"))
                .attr("stroke-width", 8 * global.resources.scale * 2);
            node.select("g.figure").remove();
            node.select("g.name").remove();
        } else if (handle.select("g.node").classed("geonode")) {
            node.select("g.node").classed("geonode-trace", true);
            this.update_geo_style();
            node.select("g.color circle")
                .attr("r", 79)
                .attr("stroke-width", 8 * global.resources.scale * 2);
            node.select("g.figure").remove();
            node.select("g.name").remove();
        } else {
            node.selectAll("[fill]:not([fill='transparent']):not(.mask),[stroke]").attr("fill", "#00000099").attr("stroke", "#ffffff88").attr("stroke-width", "0.5").attr("opacity", "0.7");
        }
        node.attr("id", uuid());
        group.node().insertBefore(node.node(), handle.node());
        make_ids_unique(node.node().ownerSVGElement, node.node());
    };
    const node_remove = () => {
        if (node !== null) {
            node.remove();
            node = null;
        }
    };

    const position = {
        x11: 0,
        x12: 0,
        y11: 0,
        y12: 0,
        x21: 0,
        x22: 0,
        y21: 0,
        y22: 0
    };

    const line_create = (handle) => {
        group.node().insertBefore(line_1.node(), handle.node());
        group.node().insertBefore(line_2.node(), handle.node());
        marker_group.node().appendChild(marker.node());
        group.node().insertBefore(marker_group.node(), handle.node());
    };

    const line_update = () => {
        line_1.attr("x1", position.x11).attr("y1", position.y11);
        line_1.attr("x2", position.x12).attr("y2", position.y12);
        line_2.attr("x1", position.x21).attr("y1", position.y21);
        line_2.attr("x2", position.x22).attr("y2", position.y22);
        marker.attr("x", position.x12).attr("y", position.y12);
        let arrow_rotation = ((Math.atan2(position.y12 - position.y11, position.x12 - position.x11) + Math.PI / 2) * 360) / (Math.PI * 2);
        marker_group.attr("transform", `translate(${position.x12},${position.y12}) rotate(${arrow_rotation})`);
    };

    this.remove = () => {
        line_1.remove();
        line_2.remove();
        marker.remove();
        marker_group.remove();
        node_remove();
    };
    let offset_reach = false;
    this.init = ({position, handle, color, offset}) => {
        offset_reach = false;
        if (offset === undefined) {
            marker.style("visibility", "hidden");
            marker_offset = 0;
        } else {
            marker.style("visibility", null);
            marker_offset = offset;
        }
        marker.attr("fill", color);
        line_2.attr("stroke", color);
        line_create(handle);
        node_mirror(handle);
        this.start(position);
    };

    this.distance = () => {
        //log.debug("Trace.distance", position);
        return Math.sqrt(Math.pow(position.x22 - position.x11, 2) + Math.pow(position.y22 - position.y11, 2));
    };

    this.distance_1 = () => {
        return Math.sqrt(Math.pow(position.x12 - position.x11, 2) + Math.pow(position.y12 - position.y11, 2));
    };

    this.distance_2 = () => {
        return Math.sqrt(Math.pow(position.x22 - position.x21, 2) + Math.pow(position.y22 - position.y21, 2));
    };

    this.start = ({x, y}) => {
        line_1.attr("stroke-width", (global.app.scale.wb / 96) * 3);
        position.x11 = x;
        position.y11 = y;
        position.x12 = x;
        position.y12 = y;
        position.x21 = x;
        position.y21 = y;
        position.x22 = x;
        position.y22 = y;
        line_update();
        log.debug("Trace.start", position);
    };

    this.offset = () => {
        return {
            x: position.x12 - position.x11,
            y: position.y12 - position.y11
        };
    };
    let dx, dy;
    this.end = ({x, y}) => {
        const scale = global.resources.scale_factor;
        const distance = this.distance_1() / scale;
        const offset = marker_offset;
        if (distance < offset && !offset_reach) {
            position.x11 = x;
            position.y11 = y;
        } else {
            if (!offset_reach) {
                dx = position.x12 - position.x11;
                dy = position.y12 - position.y11;
            }
            offset_reach = true;

            position.x12 = x + dx;
            position.y12 = y + dy;
            position.x11 = x;
            position.y11 = y;
            position.x21 = position.x12;
            position.y21 = position.y12;
        }
        line_update();
        //log.debug("Trace.end", position);
    };
};

const style = new Style();

Trace.transform = new Transform({k: 1});
Trace.transform.on_scale(({k}) => {
    style.rule_set("scene_trace_marker_scale", `.trace_marker { transform: scale(${1 / k});}`);
});

export default Trace;
